import React, {useState} from 'react';
import css from './PotImageUpload.module.scss';
import ImagesService from '../../../services/domain/ImagesService';
import LinksProvider from '../../../services/http/LinksProvider';
import {Field} from "formik";
import {useToasts} from "react-toast-notifications";
import {withTranslation} from "../../../i18n";
import ButtonSpinner from "../../../components/common/button-spinner/ButtonSpinner";

const namespacesRequired = ['common'];
const maxUploadFileSize = 15 * 1000 * 1000;

const PotImageUpload = (props) => {

  const {addToast} = useToasts();
  const [selectedImage, setSelectedImage] = useState(props.value);
  const [downloading, setDownloading] = useState(false);

  const onChange = (setFieldValue) => {
    return (e) => {
      if (!e || !e.target || !e.target.files || !e.target.files.length) {
        return;
      }

      const fileSize = e && e.target && e.target.files && e.target.files[0] && e.target.files[0].size ? e.target.files[0].size : null;

      setDownloading(true);
      ImagesService.upload(LinksProvider.get(LinksProvider.API.POTS.TMP_IMAGE), e.target.files[0])
          .then((picture) => {
            setSelectedImage(picture.url);
            setFieldValue(props.inputName, picture.url);
          })
        .catch(error => {
          console.log("error while uploading pot image : ", JSON.stringify(error));
          console.log("fileSize : ", fileSize);
          if (error.data && error.data.errors && error.data.errors.length) {
            addToast(props.t('common:errors.' + error.data.errors[0].code) , {
              appearance: 'error', autoDismiss: true, pauseOnHover: true
            })
          } else if (error && error.message === 'Network Error' && fileSize > maxUploadFileSize) {
            addToast(props.t('common:errors.E_MAX_SIZE_EXCEEDED') , {
              appearance: 'error', autoDismiss: true, pauseOnHover: true
            })
          } else {
            addToast(props.t('common:errors.DEFAULT_ERROR_MESSAGE') , {
              appearance: 'error', autoDismiss: true, pauseOnHover: true
            })
          }
        })
        .finally(() => setDownloading(false));
    };
  };

  const reset = (setFieldValue) => {

    return () => {
      setSelectedImage(null);
      setFieldValue(props.inputName, null);
    }

  };

  return (

      <Field name={props.inputName} id={props.inputId}>
        {({field: {value}, form: {setFieldValue}}) => (<div className={css.img__upload}>
          <label htmlFor={props.inputId} className={css.label}>
            {props.inputLabel}
          </label>

          <div className={css.input__file}>

            <figure className={css.img__rendering} style={{
              backgroundImage: `url('${selectedImage || props.defaultImage}')`
            }}>

              {selectedImage && (<button type="button" onClick={reset(setFieldValue)}>
                <img srcSet={'/static/images/pictos/icon-close-secondary.svg'}/>
              </button>)}
            </figure>

            <section className={css.upload__desc}>
              <h3>{props.label}</h3>
              <p>{props.format}</p>
              <label htmlFor={props.inputId} className={css.btn__light}>
                {downloading && (<ButtonSpinner customClass={css.download__spinner} loading={downloading}/>)}
                <span>
                {props.cta}
                </span>
                <input type="file"
                       onChange={onChange(setFieldValue)}
                       name={props.inputName}
                       id={props.inputId}
                       accept='.png,.jpg,.jpeg'
                       className={css.input__hidden}
                       ref={props.anchorRef}
                />
              </label>
            </section>
          </div>
        </div>)}
      </Field>);
};

export default withTranslation(namespacesRequired)(PotImageUpload);
